<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Email"
    seFeDataSubtitle="An email component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <div class="docs-content">
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
        <se-fe-card-content>
          <p>Use this component for email inputs</p>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card class="form-example">
        <se-fe-card-header seFeDataTitle="Example Code"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-email-example></se-po-email-example>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
<se-fe-toast></se-fe-toast>
